Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolate = exports.clamp = exports.Extrapolation = void 0;
var Extrapolation = exports.Extrapolation = function(Extrapolation) {
    Extrapolation["IDENTITY"] = "identity";
    Extrapolation["CLAMP"] = "clamp";
    Extrapolation["EXTEND"] = "extend";
    return Extrapolation;
}({});
var _worklet_12947029934943_init_data = {
    code: "function getVal(type,coef,val,leftEdgeOutput,rightEdgeOutput,x){const{Extrapolation}=this.__closure;switch(type){case Extrapolation.IDENTITY:return x;case Extrapolation.CLAMP:if(coef*val<coef*leftEdgeOutput){return leftEdgeOutput;}return rightEdgeOutput;case Extrapolation.EXTEND:default:return val;}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["getVal","type","coef","val","leftEdgeOutput","rightEdgeOutput","x","Extrapolation","__closure","IDENTITY","CLAMP","EXTEND"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AA6BA,SAAAA,MAASA,CACPC,IAAA,CAAmBC,IACnB,CAAYC,GACZ,CAAWC,cACX,CAAsBC,eACtB,CAAuBC,CACtB,CACF,OAAAC,aAAA,OAAAC,SAAA,CAGC,OAAQP,IAAI,EACV,IAAK,CAAAM,aAAa,CAACE,QAAQ,CACzB,MAAO,CAAAH,CAAC,CACV,IAAK,CAAAC,aAAa,CAACG,KAAK,CACtB,GAAIR,IAAI,CAAGC,GAAG,CAAGD,IAAI,CAAGE,cAAc,CAAE,CACtC,MAAO,CAAAA,cAAc,CACvB,CACA,MAAO,CAAAC,eAAe,CACxB,IAAK,CAAAE,aAAa,CAACI,MAAM,CACzB,QACE,MAAO,CAAAR,GAAG,CACd,CACF"}',
    version: "3.5.4"
};
var getVal = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var getVal = function getVal(type, coef, val, leftEdgeOutput, rightEdgeOutput, x) {
        switch(type){
            case Extrapolation.IDENTITY:
                return x;
            case Extrapolation.CLAMP:
                if (coef * val < coef * leftEdgeOutput) {
                    return leftEdgeOutput;
                }
                return rightEdgeOutput;
            case Extrapolation.EXTEND:
            default:
                return val;
        }
    };
    getVal.__closure = {
        Extrapolation: Extrapolation
    };
    getVal.__initData = _worklet_12947029934943_init_data;
    getVal.__workletHash = 12947029934943;
    getVal.__stackDetails = _e;
    return getVal;
}();
var _worklet_9992753606300_init_data = {
    code: "function isExtrapolate(value){const{Extrapolation}=this.__closure;return value===Extrapolation.EXTEND||value===Extrapolation.CLAMP||value===Extrapolation.IDENTITY;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["isExtrapolate","value","Extrapolation","__closure","EXTEND","CLAMP","IDENTITY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AAqDA,SAAAA,aAASA,CAAcC,KAAA,CAAc,OAAAC,aAAA,OAAAC,SAAA,CAGnC,MACE,CAAAF,KAAK,GAAKC,aAAa,CAACE,MAAM,EAC9BH,KAAK,GAAKC,aAAa,CAACG,KAAK,EAC7BJ,KAAK,GAAKC,aAAa,CAACI,QAAQ,CAEpC"}',
    version: "3.5.4"
};
var isExtrapolate = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var isExtrapolate = function isExtrapolate(value) {
        return value === Extrapolation.EXTEND || value === Extrapolation.CLAMP || value === Extrapolation.IDENTITY;
    };
    isExtrapolate.__closure = {
        Extrapolation: Extrapolation
    };
    isExtrapolate.__initData = _worklet_9992753606300_init_data;
    isExtrapolate.__workletHash = 9992753606300;
    isExtrapolate.__stackDetails = _e;
    return isExtrapolate;
}();
var _worklet_14909900493946_init_data = {
    code: 'function validateType(type){const{Extrapolation,isExtrapolate}=this.__closure;const extrapolationConfig={extrapolateLeft:Extrapolation.EXTEND,extrapolateRight:Extrapolation.EXTEND};if(!type){return extrapolationConfig;}if(typeof type===\'string\'){if(!isExtrapolate(type)){throw new Error("[Reanimated] Unsupported value for \\"interpolate\\" \\nSupported values: [\\"extend\\", \\"clamp\\", \\"identity\\", Extrapolatation.CLAMP, Extrapolatation.EXTEND, Extrapolatation.IDENTITY]\\n Valid example:\\n        interpolate(value, [inputRange], [outputRange], \\"clamp\\")");}extrapolationConfig.extrapolateLeft=type;extrapolationConfig.extrapolateRight=type;return extrapolationConfig;}if(type.extrapolateLeft&&!isExtrapolate(type.extrapolateLeft)||type.extrapolateRight&&!isExtrapolate(type.extrapolateRight)){throw new Error("[Reanimated] Unsupported value for \\"interpolate\\" \\nSupported values: [\\"extend\\", \\"clamp\\", \\"identity\\", Extrapolatation.CLAMP, Extrapolatation.EXTEND, Extrapolatation.IDENTITY]\\n Valid example:\\n      interpolate(value, [inputRange], [outputRange], {\\n        extrapolateLeft: Extrapolation.CLAMP,\\n        extrapolateRight: Extrapolation.IDENTITY\\n      }})");}Object.assign(extrapolationConfig,type);return extrapolationConfig;}',
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["validateType","type","Extrapolation","isExtrapolate","__closure","extrapolationConfig","extrapolateLeft","EXTEND","extrapolateRight","Error","Object","assign"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AA+DA,SAAAA,aAAAC,IAAA,QAAAC,aAAA,CAAAC,aAAA,OAAAC,SAAA,CACA,MAAAC,mBAAA,EACAC,eAAS,CAAYJ,aAAuD,CAAAK,MAAA,CAE1EC,gBAAA,CAAAN,aAAA,CAAAK,MACA,E,GACE,CAAAN,IAAA,EACA,OAAAI,mBAAkB,CACpB,CAEA,GAAI,MAAO,CAAAJ,IAAA,aACT,IAAAE,aAAO,CAAAF,IAAA,EAAmB,CAC5B,UAAAQ,KAAA,+QAEA,CACEJ,mBAAmB,CAAAC,eAAO,CAAAL,IAAA,C,mBACT,CAAAO,gBAAA,CAAAP,IAAA,CAIjB,OAAAI,mBAAA,C,CAIF,GAAAJ,IAAA,CAAAK,eAAA,GAAAH,aAAA,CAAAF,IAAA,CAAAK,eAAA,GAAAL,IAAA,CAAAO,gBAAA,GAAAL,aAAA,CAAAF,IAAA,CAAAO,gBAAA,G,+XAEA,CACAE,MACG,CAAAC,MAAK,CAAAN,mBAAoB,CAAAJ,IAAA,E,MAG1B,CAAAI,mBAAe,C"}',
    version: "3.5.4"
};
var validateType = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var validateType = function validateType(type) {
        var extrapolationConfig = {
            extrapolateLeft: Extrapolation.EXTEND,
            extrapolateRight: Extrapolation.EXTEND
        };
        if (!type) {
            return extrapolationConfig;
        }
        if (typeof type === "string") {
            if (!isExtrapolate(type)) {
                throw new Error('[Reanimated] Unsupported value for "interpolate" \nSupported values: ["extend", "clamp", "identity", Extrapolatation.CLAMP, Extrapolatation.EXTEND, Extrapolatation.IDENTITY]\n Valid example:\n        interpolate(value, [inputRange], [outputRange], "clamp")');
            }
            extrapolationConfig.extrapolateLeft = type;
            extrapolationConfig.extrapolateRight = type;
            return extrapolationConfig;
        }
        if (type.extrapolateLeft && !isExtrapolate(type.extrapolateLeft) || type.extrapolateRight && !isExtrapolate(type.extrapolateRight)) {
            throw new Error('[Reanimated] Unsupported value for "interpolate" \nSupported values: ["extend", "clamp", "identity", Extrapolatation.CLAMP, Extrapolatation.EXTEND, Extrapolatation.IDENTITY]\n Valid example:\n      interpolate(value, [inputRange], [outputRange], {\n        extrapolateLeft: Extrapolation.CLAMP,\n        extrapolateRight: Extrapolation.IDENTITY\n      }})');
        }
        Object.assign(extrapolationConfig, type);
        return extrapolationConfig;
    };
    validateType.__closure = {
        Extrapolation: Extrapolation,
        isExtrapolate: isExtrapolate
    };
    validateType.__initData = _worklet_14909900493946_init_data;
    validateType.__workletHash = 14909900493946;
    validateType.__stackDetails = _e;
    return validateType;
}();
var _worklet_13384238271996_init_data = {
    code: "function internalInterpolate(x,narrowedInput,extrapolationConfig){const{getVal}=this.__closure;const{leftEdgeInput:leftEdgeInput,rightEdgeInput:rightEdgeInput,leftEdgeOutput:leftEdgeOutput,rightEdgeOutput:rightEdgeOutput}=narrowedInput;if(rightEdgeInput-leftEdgeInput===0)return leftEdgeOutput;const progress=(x-leftEdgeInput)/(rightEdgeInput-leftEdgeInput);const val=leftEdgeOutput+progress*(rightEdgeOutput-leftEdgeOutput);const coef=rightEdgeOutput>=leftEdgeOutput?1:-1;if(coef*val<coef*leftEdgeOutput){return getVal(extrapolationConfig.extrapolateLeft,coef,val,leftEdgeOutput,rightEdgeOutput,x);}else if(coef*val>coef*rightEdgeOutput){return getVal(extrapolationConfig.extrapolateRight,coef,val,leftEdgeOutput,rightEdgeOutput,x);}return val;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["internalInterpolate","x","narrowedInput","extrapolationConfig","getVal","__closure","leftEdgeInput","rightEdgeInput","leftEdgeOutput","rightEdgeOutput","progress","val","coef","extrapolateLeft","extrapolateRight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AA2GA,SAAAA,mBAASA,CACPC,CAAC,CAAQC,aACT,CAAyCC,mBACzC,CAAgD,OAAAC,MAAA,OAAAC,SAAA,CAGhD,KAAM,CAAEC,aAAa,CAAbA,aAAa,CAAEC,cAAc,CAAdA,cAAc,CAAEC,cAAc,CAAdA,cAAc,CAAEC,eAAA,CAAAA,eAAgB,CAAC,CACtEP,aAAa,CACf,GAAIK,cAAc,CAAGD,aAAa,GAAK,CAAC,CAAE,MAAO,CAAAE,cAAc,CAC/D,KAAM,CAAAE,QAAQ,CAAG,CAACT,CAAC,CAAGK,aAAa,GAAKC,cAAc,CAAGD,aAAa,CAAC,CACvE,KAAM,CAAAK,GAAG,CAAGH,cAAc,CAAGE,QAAQ,EAAID,eAAe,CAAGD,cAAc,CAAC,CAC1E,KAAM,CAAAI,IAAI,CAAGH,eAAe,EAAID,cAAc,CAAG,CAAC,CAAG,CAAC,CAAC,CAEvD,GAAII,IAAI,CAAGD,GAAG,CAAGC,IAAI,CAAGJ,cAAc,CAAE,CACtC,MAAO,CAAAJ,MAAM,CACXD,mBAAmB,CAACU,eAAe,CACnCD,IAAI,CACJD,GAAG,CACHH,cAAc,CACdC,eAAe,CACfR,CACF,CAAC,CACH,CAAC,IAAM,IAAIW,IAAI,CAAGD,GAAG,CAAGC,IAAI,CAAGH,eAAe,CAAE,CAC9C,MAAO,CAAAL,MAAM,CACXD,mBAAmB,CAACW,gBAAgB,CACpCF,IAAI,CACJD,GAAG,CACHH,cAAc,CACdC,eAAe,CACfR,CACF,CAAC,CACH,CAEA,MAAO,CAAAU,GAAG,CACZ"}',
    version: "3.5.4"
};
var internalInterpolate = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var internalInterpolate = function internalInterpolate(x, narrowedInput, extrapolationConfig) {
        var leftEdgeInput = narrowedInput.leftEdgeInput, rightEdgeInput = narrowedInput.rightEdgeInput, leftEdgeOutput = narrowedInput.leftEdgeOutput, rightEdgeOutput = narrowedInput.rightEdgeOutput;
        if (rightEdgeInput - leftEdgeInput === 0) return leftEdgeOutput;
        var progress = (x - leftEdgeInput) / (rightEdgeInput - leftEdgeInput);
        var val = leftEdgeOutput + progress * (rightEdgeOutput - leftEdgeOutput);
        var coef = rightEdgeOutput >= leftEdgeOutput ? 1 : -1;
        if (coef * val < coef * leftEdgeOutput) {
            return getVal(extrapolationConfig.extrapolateLeft, coef, val, leftEdgeOutput, rightEdgeOutput, x);
        } else if (coef * val > coef * rightEdgeOutput) {
            return getVal(extrapolationConfig.extrapolateRight, coef, val, leftEdgeOutput, rightEdgeOutput, x);
        }
        return val;
    };
    internalInterpolate.__closure = {
        getVal: getVal
    };
    internalInterpolate.__initData = _worklet_13384238271996_init_data;
    internalInterpolate.__workletHash = 13384238271996;
    internalInterpolate.__stackDetails = _e;
    return internalInterpolate;
}();
var _worklet_7925259286833_init_data = {
    code: "function interpolate(x,input,output,type){const{validateType,internalInterpolate}=this.__closure;if(input.length<2||output.length<2){throw new Error('[Reanimated] Interpolation input and output should contain at least two values.');}const extrapolationConfig=validateType(type);const length=input.length;const narrowedInput={leftEdgeInput:input[0],rightEdgeInput:input[1],leftEdgeOutput:output[0],rightEdgeOutput:output[1]};if(length>2){if(x>input[length-1]){narrowedInput.leftEdgeInput=input[length-2];narrowedInput.rightEdgeInput=input[length-1];narrowedInput.leftEdgeOutput=output[length-2];narrowedInput.rightEdgeOutput=output[length-1];}else{for(let i=1;i<length;++i){if(x<=input[i]){narrowedInput.leftEdgeInput=input[i-1];narrowedInput.rightEdgeInput=input[i];narrowedInput.leftEdgeOutput=output[i-1];narrowedInput.rightEdgeOutput=output[i];break;}}}}return internalInterpolate(x,narrowedInput,extrapolationConfig);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["interpolate","x","input","output","type","validateType","internalInterpolate","__closure","length","Error","extrapolationConfig","narrowedInput","leftEdgeInput","rightEdgeInput","leftEdgeOutput","rightEdgeOutput","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AAiJO,SAAAA,WAASA,CACdC,CAAC,CAAQC,KACT,CAAwBC,MACxB,CAAyBC,IACzB,CACD,OAAAC,YAAA,CAAAC,mBAAA,OAAAC,SAAA,CAEC,GAAIL,KAAK,CAACM,MAAM,CAAG,CAAC,EAAIL,MAAM,CAACK,MAAM,CAAG,CAAC,CAAE,CACzC,KAAM,IAAI,CAAAC,KAAK,CACb,iFACF,CAAC,CACH,CAEA,KAAM,CAAAC,mBAAmB,CAAGL,YAAY,CAACD,IAAI,CAAC,CAC9C,KAAM,CAAAI,MAAM,CAAGN,KAAK,CAACM,MAAM,CAC3B,KAAM,CAAAG,aAAyC,CAAG,CAChDC,aAAa,CAAEV,KAAK,CAAC,CAAC,CAAC,CACvBW,cAAc,CAAEX,KAAK,CAAC,CAAC,CAAC,CACxBY,cAAc,CAAEX,MAAM,CAAC,CAAC,CAAC,CACzBY,eAAe,CAAEZ,MAAM,CAAC,CAAC,CAC3B,CAAC,CACD,GAAIK,MAAM,CAAG,CAAC,CAAE,CACd,GAAIP,CAAC,CAAGC,KAAK,CAACM,MAAM,CAAG,CAAC,CAAC,CAAE,CACzBG,aAAa,CAACC,aAAa,CAAGV,KAAK,CAACM,MAAM,CAAG,CAAC,CAAC,CAC/CG,aAAa,CAACE,cAAc,CAAGX,KAAK,CAACM,MAAM,CAAG,CAAC,CAAC,CAChDG,aAAa,CAACG,cAAc,CAAGX,MAAM,CAACK,MAAM,CAAG,CAAC,CAAC,CACjDG,aAAa,CAACI,eAAe,CAAGZ,MAAM,CAACK,MAAM,CAAG,CAAC,CAAC,CACpD,CAAC,IAAM,CACL,IAAK,GAAI,CAAAQ,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGR,MAAM,CAAE,EAAEQ,CAAC,CAAE,CAC/B,GAAIf,CAAC,EAAIC,KAAK,CAACc,CAAC,CAAC,CAAE,CACjBL,aAAa,CAACC,aAAa,CAAGV,KAAK,CAACc,CAAC,CAAG,CAAC,CAAC,CAC1CL,aAAa,CAACE,cAAc,CAAGX,KAAK,CAACc,CAAC,CAAC,CACvCL,aAAa,CAACG,cAAc,CAAGX,MAAM,CAACa,CAAC,CAAG,CAAC,CAAC,CAC5CL,aAAa,CAACI,eAAe,CAAGZ,MAAM,CAACa,CAAC,CAAC,CACzC,MACF,CACF,CACF,CACF,CAEA,MAAO,CAAAV,mBAAmB,CAACL,CAAC,CAAEU,aAAa,CAAED,mBAAmB,CAAC,CACnE"}',
    version: "3.5.4"
};
var interpolate = exports.interpolate = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var interpolate = function interpolate(x, input, output, type) {
        if (input.length < 2 || output.length < 2) {
            throw new Error("[Reanimated] Interpolation input and output should contain at least two values.");
        }
        var extrapolationConfig = validateType(type);
        var length = input.length;
        var narrowedInput = {
            leftEdgeInput: input[0],
            rightEdgeInput: input[1],
            leftEdgeOutput: output[0],
            rightEdgeOutput: output[1]
        };
        if (length > 2) {
            if (x > input[length - 1]) {
                narrowedInput.leftEdgeInput = input[length - 2];
                narrowedInput.rightEdgeInput = input[length - 1];
                narrowedInput.leftEdgeOutput = output[length - 2];
                narrowedInput.rightEdgeOutput = output[length - 1];
            } else {
                for(var i = 1; i < length; ++i){
                    if (x <= input[i]) {
                        narrowedInput.leftEdgeInput = input[i - 1];
                        narrowedInput.rightEdgeInput = input[i];
                        narrowedInput.leftEdgeOutput = output[i - 1];
                        narrowedInput.rightEdgeOutput = output[i];
                        break;
                    }
                }
            }
        }
        return internalInterpolate(x, narrowedInput, extrapolationConfig);
    };
    interpolate.__closure = {
        validateType: validateType,
        internalInterpolate: internalInterpolate
    };
    interpolate.__initData = _worklet_7925259286833_init_data;
    interpolate.__workletHash = 7925259286833;
    interpolate.__stackDetails = _e;
    return interpolate;
}();
var _worklet_1833118047486_init_data = {
    code: "function clamp(value,min,max){return Math.min(Math.max(value,min),max);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts",
    sourceMap: '{"version":3,"names":["clamp","value","min","max","Math"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/interpolation.ts"],"mappings":"AAkMO,SAAAA,KAASA,CAAMC,KAAA,CAAaC,GAAE,CAAWC,GAAE,CAAW,CAE3D,MAAO,CAAAC,IAAI,CAACF,GAAG,CAACE,IAAI,CAACD,GAAG,CAACF,KAAK,CAAEC,GAAG,CAAC,CAAEC,GAAG,CAAC,CAC5C"}',
    version: "3.5.4"
};
var clamp = exports.clamp = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var clamp = function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    clamp.__closure = {};
    clamp.__initData = _worklet_1833118047486_init_data;
    clamp.__workletHash = 1833118047486;
    clamp.__stackDetails = _e;
    return clamp;
}();
